/**
 * Fechas en la hora de QUIEN CAPTURA, no en UTC.
 *
 * POR QUE EXISTE: `new Date().toISOString().split('T')[0]` devuelve el dia en UTC.
 * En Puebla (UTC-6) eso significa que de las 18:00 en adelante los formularios
 * proponian la fecha de MAÑANA. Se detecto en el recorrido del 14-sep-2026: a las
 * 22:5x, la Nueva Recepcion traia 14/09 y el Check List traia 13/09 — el mismo
 * minuto, dos dias distintos. Y esas fechas son las que alimentan los tiempos.
 */

/** El dia de hoy como 'YYYY-MM-DD', en la zona horaria del navegador. */
export function hoyLocal() {
  const d = new Date();
  const mes = String(d.getMonth() + 1).padStart(2, '0');
  const dia = String(d.getDate()).padStart(2, '0');
  return `${d.getFullYear()}-${mes}-${dia}`;
}

/** Una fecha cualquiera como 'YYYY-MM-DD' local. Vacio si no es una fecha. */
export function comoFechaLocal(valor) {
  if (!valor) return '';
  const d = valor instanceof Date ? valor : new Date(valor);
  if (isNaN(d.getTime())) return '';
  const mes = String(d.getMonth() + 1).padStart(2, '0');
  const dia = String(d.getDate()).padStart(2, '0');
  return `${d.getFullYear()}-${mes}-${dia}`;
}

/**
 * Una fecha para mostrar como 'DD/MM/AAAA', SIN pasar por UTC.
 *
 * POR QUE EXISTE: la API devuelve las columnas DATE como texto 'YYYY-MM-DD'
 * (dateStrings en config/database.js). `new Date('2026-10-12')` lo lee como
 * medianoche UTC, y en UTC-6 `toLocaleDateString` muestra el 11/10: el mismo
 * pedido salía con un día distinto en Compras y en Almacén (B5c, 1-nov-2026).
 * Aquí el texto 'YYYY-MM-DD' (o 'YYYY-MM-DD HH:MM:SS', que ya viene en hora local)
 * se corta tal cual; sólo un instante con zona (ISO con Z) se pasa a la hora local.
 */
export function fechaCorta(valor) {
  if (!valor) return '-';
  if (typeof valor === 'string') {
    const m = valor.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2})(?::\d{2}(?:\.\d+)?)?)?(Z|[+-]\d{2}:?\d{2})?$/);
    if (m && !m[6]) return `${m[3]}/${m[2]}/${m[1]}`;
  }
  const d = valor instanceof Date ? valor : new Date(valor);
  if (isNaN(d.getTime())) return '-';
  return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`;
}
